export default __webpack_public_path__ + "static/media/home-interior-design-start-project-bg.567800fd.jpg";